import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';

const clients = [
   { img: '/assets/images/project/oriental.png', name: 'Oriental Business Solutions' },
  { img: '/assets/images/project/orientalpay.png', name: 'orientalpay' },
 { img: '/assets/images/project/bringmeal.jpg', name: 'Bringmeal' },

];

export default function OurClients() {
  return (
    <Layout>
      {/* Page Header */}
      <section className="relative overflow-hidden min-h-[280px] md:min-h-[360px] flex items-center bg-brand-dark">
        <video className="absolute inset-0 h-full w-full object-cover opacity-40" autoPlay muted loop playsInline>
          <source src="/our-clients.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/10 to-brand/30"></div>
        <div className="container relative z-10 py-20">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mb-4">Our Clients</h2>
            <ul className="flex justify-center items-center gap-3 text-white/70 text-sm list-none p-0 m-0">
              <li><Link className="hover:text-brand transition-colors" to="/">Home</Link></li>
              <li><span className="text-white/40">/</span></li>
              <li className="text-brand">Our Clients</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Clients Grid */}
      <section className="py-20 bg-white">
        <div className="container">
          <div className="row gutter-y-30">
            {clients.map(({ img, name }, i) => (
              <div
                key={name}
                className={`col-xl-4 wow ${i % 3 === 1 ? 'fadeInRight' : 'fadeInLeft'}`}
                data-wow-delay={`${(i % 3) * 100}ms`}
                data-wow-duration="1500ms"
              >
                <div className="group relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                  <img src={img} alt={name} className="w-full h-60 object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-brand-dark/0 group-hover:bg-brand-dark/70 transition-all duration-300 flex items-end">
                    <div className="p-6 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300 w-full">
                      <span className="text-brand text-xs font-semibold uppercase tracking-widest mb-1 block">Tech</span>
                      <h3 className="text-white font-bold font-heading text-xl">{name}</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}

